import { ComponentProps, FC } from "react";
import { Section } from "@/components/Html/Section";
import { Title } from "@/components/home/Title/Title";
import { TechBlog } from "@/lib/contentful/contentModel/techBlog";
import { PostItem } from "../../../PostItem/PostItem";

interface Props {
  posts: (ComponentProps<typeof PostItem>["post"] & DeepPick<TechBlog, "sys.id">)[];
}

export const RelatedPosts: FC<Props> = ({ posts }) => {
  return (
    <Section className="flex flex-col pt-[16px] md:pt-[24px]">
      <Title title="関連記事" />
      <div className="grid grid-cols-1 gap-[16px] md:grid-cols-2 md:gap-[24px]">
        {posts.map((post) => (
          <PostItem key={post.sys.id} post={post} />
        ))}
      </div>
    </Section>
  );
};
